import React, { useRef } from 'react';
import './SynchronousVideos.module.css';
import { captions } from '../../../../public/video.vtt';

const SynchronousVideo = ({
  url,
  title,
  description,
  thumbnail,
  attachVideoPlayer
}) => {
  const video = useRef();

  const handleLoad = () => {
    video.current.pause();
    attachVideoPlayer(() => {
      if (video.current.currentTime !== 0) {
        video.current.currentTime = 0;
      }
      video.current.play();
    });
  };

  return (
    <div>
      <video
        autoPlay={true}
        muted="true"
        src={url}
        ref={video}
        onLoadedMetadata={handleLoad}
        playsInline={true}
        poster={thumbnail}
      >
        <track src={captions} kind="captions" />
      </video>
      <div styleName="caption">
        <p styleName="title">{title}</p>
        <p styleName="description">{description}</p>
      </div>
    </div>
  );
};

export default SynchronousVideo;
